import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Modal,
  Button,
  Label,
  InputText,
  MultiselectWithTags,
} from '@teo/components';
import { Plus } from '@teo/components/icons';

const EditCertificate = ({
  onClose,
  setTitleCertificate,
  titleCertificate,
  setModulesCertificate,
  modulesCertificate,
  handleChangeTraining,
}) => {
  const { t } = useTranslation();
  const [myFilter, setMyFilter] = useState('');

  const [title, setTitle] = useState(titleCertificate || '');
  const [modals, setModals] = useState(
    modulesCertificate
      ? modulesCertificate?.map((mdl) => ({ key: mdl, label: mdl }))
      : []
  );
  const handleAddModal = () => {
    if (myFilter) {
      setModals((prev) => [
        ...prev,
        {
          key: myFilter,
          label: myFilter,
        },
      ]);
    }
    setMyFilter('');
  };

  const save = async () => {
    setTitleCertificate(title);
    const madalList = modals?.map((mdl) => mdl?.label);
    setModulesCertificate(modals?.map((mdl) => mdl?.label));
    handleChangeTraining &&
      handleChangeTraining({
        titleCertificate: title,
        modulesCertificate: madalList,
      });
    onClose();
  };

  return (
    <>
      <Modal isOpen>
        <Modal.Header onClose={onClose}>
          {t('pages.learning_path.settings.edit_certificate')}
        </Modal.Header>
        <Modal.Body>
          <div>
            <Label htmlFor="link-registration">
              {t('pages.learning_path.settings.title_certificate')}
            </Label>
            <InputText
              id="link-registration"
              onChange={(event) => {
                setTitle(event.target.value);
              }}
              value={title}
              placeholder={t('pages.learning_path.settings.title_certificate')}
              required
            />
          </div>
          <div className="mt-5 flex flex-col">
            <Label htmlFor="link-registration">
              {t('pages.learning_path.settings.modules_certificate')}
            </Label>
            <div>
              <MultiselectWithTags
                removeButtonLabel="clear"
                toggleSelectionLabel="toggle"
                onChange={(param) => {
                  setMyFilter('');
                  setModals(param);
                }}
                onCommitQuery={() => {
                  handleAddModal && myFilter && handleAddModal();
                  setMyFilter('');
                }}
                onRemoved={(value) => {
                  setMyFilter('');
                  setModals(value);
                }}
                options={[]}
                query={myFilter}
                setQuery={(query) => setMyFilter(query)}
                value={modals || []}
                addTagLabel={`'${myFilter}' - ${t(
                  'pages.learning_path.settings.add_modal'
                )}`}
                handleAddTag={handleAddModal}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="flex w-full justify-between">
            <Button variant="ghost" onClick={onClose}>
              {t('button.cancel')}
            </Button>

            <Button onClick={() => save()}>
              {t('pages.learning_path.settings.edit_certificate')}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default EditCertificate;
